$exso_sheets_site $mol_page
	site_arg* *
	body /
		<= Info $mol_card content /
			<= Info_title $mol_view sub / <= info_title \
			<= Info_meta $mol_view sub / <= meta @ \{d} станков, {s} смен
		<= Devices $exso_table
			title @ \Буровые станки
			items <= devices <= shifts <= all_shifts /$exso_sheets_shift
			items_map => shifts_map
			columns_meta <= columns_meta*shift *
			columns /
				\device
				\value
				\wells_count
				\downtime
				\fuel
				\fuel__value
				\redrill
			item_columns* => device_columns*
			Item* <= Device_row* $mol_link
				arg <= _device_arg* <= device_arg* *
				sub <= device_columns*
		<= Blowings $exso_table
			title @ \Взрывные работы
			items <= blowings <= all_blowings /$exso_sheets_blowing
			tools / <= Blowings_tools $mol_check_box
				title @ \Подробнее
				checked? <=> blowings_all? false
			reverse true
			columns_meta <= columns_meta*blowing *
			columns <= blowing_columns /
				\date
				\block
				\blasted
	blowing_columns_all /
		\date
		\block
		\mesh
		\burnt
		\blasted
		\state
